document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const newsletter = document.querySelector('[data-newsletter-popup]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');

  document.querySelectorAll('[data-commission-form]').forEach((form) => {
    const photoInputs = [...form.querySelectorAll('[data-photo-input]')];
    const photoError = form.querySelector('[data-photo-error]');
    const addOnInputs = [...form.querySelectorAll('[data-add-on]')];
    const addOnError = form.querySelector('[data-addon-error]');
    const variantControl = form.querySelector('[data-variant-select]');
    const productPrice = document.querySelector('[data-product-price]');
    const estimatedTotal = form.querySelector('[data-estimated-total]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const submitButton = form.querySelector('[data-submit-button]');
    const maximumBytes = 20 * 1024 * 1024;
    const supportedTypes = ['image/jpeg', 'image/png', 'image/webp'];
    const currency = form.dataset.currency || 'USD';

    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency
    }).format(cents / 100);

    const selectedVariantOption = () => {
      if (variantControl?.tagName === 'SELECT') return variantControl.selectedOptions[0];
      return variantControl;
    };

    const updateEstimate = () => {
      const variantOption = selectedVariantOption();
      const variantPrice = Number(variantOption?.dataset.price || 0);
      const addOnPrice = addOnInputs
        .filter((input) => input.checked)
        .reduce((total, input) => total + Number(input.dataset.price || 0), 0);
      const quantity = Math.max(1, Number(quantityInput?.value || 1));

      if (productPrice && variantPrice) productPrice.textContent = formatMoney(variantPrice);
      if (estimatedTotal) estimatedTotal.textContent = formatMoney((variantPrice + addOnPrice) * quantity);
      if (submitButton && variantOption) submitButton.disabled = variantOption.dataset.available === 'false';
    };

    const validatePhoto = (input) => {
      const file = input.files?.[0];
      const picker = input.parentElement?.querySelector('[data-upload-picker]');
      const name = picker?.querySelector('[data-file-name]');
      const action = picker?.querySelector('[data-file-action]');
      const valid = !file || (supportedTypes.includes(file.type) && file.size <= maximumBytes);
      input.setCustomValidity(valid ? '' : photoError?.textContent.trim() || 'Please choose a supported image under 20 MB.');
      if (name) name.textContent = file && valid ? file.name : name.dataset.emptyLabel || 'No file selected';
      if (action) action.textContent = file && valid ? action.dataset.changeLabel || 'Change photo' : action.dataset.chooseLabel || 'Choose photo';
      picker?.classList.toggle('has-file', Boolean(file && valid));
      return valid;
    };

    photoInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const valid = validatePhoto(input);
        if (photoError) photoError.hidden = valid;
      });
    });

    variantControl?.addEventListener('change', updateEstimate);
    quantityInput?.addEventListener('input', updateEstimate);
    addOnInputs.forEach((input) => input.addEventListener('change', updateEstimate));
    updateEstimate();

    form.addEventListener('submit', async (event) => {
      const invalidInput = photoInputs.find((input) => !validatePhoto(input));
      if (invalidInput) {
        event.preventDefault();
        if (photoError) photoError.hidden = false;
        invalidInput.focus();
        invalidInput.reportValidity();
        return;
      }

      const selectedAddOns = addOnInputs.filter((input) => input.checked);
      if (!selectedAddOns.length || form.dataset.addOnsQueued === 'true') return;

      event.preventDefault();
      if (addOnError) addOnError.hidden = true;

      const originalButtonText = submitButton?.textContent;
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Adding selected services…';
      }

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: selectedAddOns.map((input) => ({
              id: Number(input.value),
              quantity: Math.max(1, Number(quantityInput?.value || 1)),
              properties: {
                '_Commission add-on for': form.dataset.productTitle || 'Custom pet portrait'
              }
            }))
          })
        });

        if (!response.ok) throw new Error('Unable to add commission services.');
        form.dataset.addOnsQueued = 'true';
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;
          form.requestSubmit(submitButton);
        } else {
          form.submit();
        }
      } catch (error) {
        if (addOnError) addOnError.hidden = false;
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;
        }
      }
    });
  });

  const setMenu = (open) => {
    if (!menuButton || !mobileMenu) return;
    menuButton.setAttribute('aria-expanded', String(open));
    mobileMenu.hidden = !open;
    body.classList.toggle('menu-open', open);
    if (open) mobileMenu.querySelector('[data-menu-close]')?.focus();
  };

  menuButton?.addEventListener('click', () => {
    setMenu(menuButton.getAttribute('aria-expanded') !== 'true');
  });
  document.querySelectorAll('[data-menu-close]').forEach((button) => {
    button.addEventListener('click', () => setMenu(false));
  });
  document.querySelectorAll('[data-mobile-menu] a').forEach((link) => {
    link.addEventListener('click', () => setMenu(false));
  });

  const setCart = (open) => {
    if (!cartDrawer) return;
    cartDrawer.hidden = !open;
    body.classList.toggle('cart-open', open);
  };
  document.querySelectorAll('[data-cart-open]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      setCart(true);
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach((button) => {
    button.addEventListener('click', () => setCart(false));
  });

  const setNewsletter = (open) => {
    if (!newsletter) return;
    newsletter.hidden = !open;
    body.classList.toggle('newsletter-open', open);
    if (open) newsletter.querySelector('[data-newsletter-close]')?.focus();
  };
  if (newsletter && !window.Shopify?.designMode && !sessionStorage.getItem('warmFeltNewsletterDismissed')) {
    const delay = Number(newsletter.dataset.delay || 4000);
    window.setTimeout(() => setNewsletter(true), delay);
  }
  document.querySelectorAll('[data-newsletter-close]').forEach((button) => {
    button.addEventListener('click', () => {
      sessionStorage.setItem('warmFeltNewsletterDismissed', 'true');
      setNewsletter(false);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setMenu(false);
      setCart(false);
      setNewsletter(false);
    }
  });

  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('[data-hero-slide]')];
    const dots = [...hero.querySelectorAll('[data-hero-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
    };
    const start = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      window.clearInterval(timer);
      timer = window.setInterval(() => show(index + 1), 6500);
    };
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        show(dotIndex);
        start();
      });
    });
    hero.addEventListener('mouseenter', () => window.clearInterval(timer));
    hero.addEventListener('mouseleave', start);
    start();
  });

  document.querySelectorAll('[data-process]').forEach((process) => {
    const tabs = [...process.querySelectorAll('[data-process-tab]')];
    const panels = [...process.querySelectorAll('[data-process-panel]')];
    const count = process.querySelector('[data-process-count]');
    let activeIndex = 0;

    const activate = (nextIndex) => {
      if (!tabs.length) return;
      activeIndex = (nextIndex + tabs.length) % tabs.length;
      tabs.forEach((tab, index) => {
        tab.setAttribute('aria-selected', String(index === activeIndex));
        if (index === activeIndex) tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
      panels.forEach((panel, index) => {
        panel.hidden = index !== activeIndex;
      });
      if (count) count.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(tabs.length).padStart(2, '0')}`;
    };

    tabs.forEach((tab, index) => tab.addEventListener('click', () => activate(index)));
    process.querySelector('[data-process-prev]')?.addEventListener('click', () => activate(activeIndex - 1));
    process.querySelector('[data-process-next]')?.addEventListener('click', () => activate(activeIndex + 1));
  });

  document.querySelectorAll('[data-card-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const move = (direction) => {
      if (!track) return;
      const card = track.querySelector('.studio-note');
      track.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || 280) + 20), behavior: 'smooth' });
    };
    carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => move(-1));
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => move(1));
  });

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('[data-reveal]').forEach((element) => observer.observe(element));
  } else {
    document.querySelectorAll('[data-reveal]').forEach((element) => element.classList.add('is-visible'));
  }
});
